import router from '@/router'
import store from '@/store'
import { loginURL } from '../../vue.dev'

router.beforeEach(async(to, from, next) => {

    const token = common_tool.getDataFromLocal('token'); //获取浏览器缓存的用户信息
    const userInfo = common_tool.getDataFromLocal('userInfo')
    const signToken = common_tool.getDataFromCookie('signToken') // ___
    const usertype = common_tool.getDataFromLocal('usertype')
    try {
        // 没有第三方的token 直接跳转首页
        if (!token) {
            store.dispatch('getToken')
        }
        if (signToken) {
            // 有单点登录token
            if (!userInfo || JSON.stringify(userInfo) === {}) {
                // 没有用户信息
                const params = { token: signToken, usertype: usertype }
                store.dispatch('login', params)
            }
        } else {
            store.dispatch('logout')
            const url = window.location.href
            if (url && url.includes('ticket')) {
                next()
            } else {
                // 没有单点登录token 跳转用户登录页面
                if (process.env.PATH_ENV !== 'dev') {
                    window.location.href = `${loginURL}&gotoUrl=${common_tool.windowUrl()}`
                }
            }
        }
        if (to.path === '/') {
            store.commit('setCurrent', null)
            store.commit('setTwoCustomData', {})
            store.commit('setApplyInfo', {})
            common_tool.clearLocalData('formRowGuid')
            common_tool.clearLocalData('record')
        }
        next()
    } catch (err) {
        next()
    }

})


// WEBPACK FOOTER //
// ./src/router/permission.js